/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontCallButton_seller$ref = any;
type StorefrontContactButton_seller$ref = any;
type StorefrontSocialShare_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontSocial_seller$ref: FragmentReference;
export type StorefrontSocial_seller = {|
  +trackedPhone: ?{|
    +phoneNumber: ?string
  |},
  +$fragmentRefs: StorefrontContactButton_seller$ref & StorefrontCallButton_seller$ref & StorefrontSocialShare_seller$ref,
  +$refType: StorefrontSocial_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontSocial_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontContactButton_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocialShare_seller",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "trackedPhone",
      "storageKey": null,
      "args": null,
      "concreteType": "Phone",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phoneNumber",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '37599e40e9e9137722e3543f09cb3b86';
module.exports = node;
